'use client'

import { createTheme, DEFAULT_THEME, MantineThemeOverride, mergeMantineTheme } from '@mantine/core'
import { defaultTheme } from './default-theme'

export const theme: MantineThemeOverride = createTheme(defaultTheme)

export const mergedTheme = mergeMantineTheme(DEFAULT_THEME, theme)
